// extracted by mini-css-extract-plugin
export default {"settingsPanel":"SettingsPanel_settingsPanel__7zOy9","settingsRowList":"SettingsPanel_settingsRowList__fHTqT"};